import React from 'react';
import styled from 'styled-components';
import CompetitionPricesFrame from '../CompetitionPricesFrame';
import ScheduleForm from './ScheduleForm';

const DetailsStyled = styled.tr` 

    &:hover {
        background: inherit !important;
    }

    position: relative;

	& > td {
		text-align: unset !important;
		padding: 20px 10px;

		&:first-of-type {
			padding-left: ${props => props.isDeviation ? 40 : 0}px;
		}
	}

	.probes_wrapper {
		#loader {
			height: 20px;
			margin-left: 5px;
		}
	}

	.row-table-details {
		display: grid !important;
		grid-template-columns: 0.5rem 1fr 1fr;
		gap: 0.25rem !important;
		align-items: stretch;
		width: 100%;
	}

	.col-table-details {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.photo-btn:hover{
		color: var(--plenoil-orange) !important;
	}

    .competition-frame {
        display: inline-flex;
        margin: 5px;
        border: 1px solid #dee2e6;
    }
`;

export default function Details(props) {
    let station = props.station;

    let stationCurrentPrices = props.stationCurrentPrices;
    let stationMineturPrices = props.stationMineturPrices;
    let stationAppPrices = props.stationAppPrices;

    return (
        <DetailsStyled>
            <td colSpan="100%">
                {stationMineturPrices.map((mEl, idx) => {
                    let singleCompetitionAppPrices = stationAppPrices[mEl.id] ?? null;

                    return (
                        <CompetitionPricesFrame 
                            key={'station-' + station.id + '-minetur-' + idx} 

                            station={station}
                            competition={mEl} 
                            app={singleCompetitionAppPrices}
                            current={stationCurrentPrices} 

                            reloadParent={props.reloadParent}
                        />
                    )
                })}

                <ScheduleForm 
                    stationId={station.id}
                />
            </td>
        </DetailsStyled>
    );
}